import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LibraryService } from 'src/app/services/library.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-generate-codes-form',
  templateUrl: './generate-codes-form.component.html',
  styleUrls: ['./generate-codes-form.component.scss'],
})
export class GenerateCodesFormComponent implements OnInit {
  submitted = false;

  @ViewChild('entryForm', { static: false }) entryForm?: NgForm;

  stepTemplates: any = [];
  isLoading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private libraryService: LibraryService,
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    this.isLoading = true;

    this.libraryService
      .generateCodes(
        this.entryForm?.value.itemIds,
        this.entryForm?.value.number,
        this.entryForm?.value.days,
      )
      .subscribe(
        (responseData: any) => {
          Swal.fire({
            icon: 'success',
            title: 'Codes Generated',
            text: 'The codes have been generated',
            showConfirmButton: false,
            timer: 1000,
            timerProgressBar: true,
          });
          this.libraryService.clearCache();
          this.isLoading = false;
          this.bsModalRef.hide();
        },
        (error) => {
          this.bsModalRef.hide();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'We were unable to create the codes',
            showConfirmButton: false,
            timer: 1000,
            timerProgressBar: true,
          });
          this.isLoading = false;
          this.bsModalRef.hide();
        },
      );
  }
}
